/**
 * Next.js client instrumentation — runs once, after the document loads and before hydration.
 *
 * `onRouterTransitionStart` is the only place the App Router reports the *start* of a client
 * navigation. Next calls it from `dispatchNavigateAction` (every <Link> click, router.push and
 * router.replace) and from `dispatchTraverseAction` (browser back/forward). Everything else the
 * router exposes — history.pushState, usePathname — fires at commit time, which is far too late to
 * start a progress bar.
 *
 * This matters here because the sidebar navigates with `router.push` rather than anchors
 * (see AppWrapper's `onLinkClick`), so anchor-click interception would miss the app's primary
 * navigation entirely.
 *
 * The import is relative on purpose: this module resolves through Next's
 * `private-next-instrumentation-client` alias rather than normal app resolution, where the `@/`
 * alias is not guaranteed.
 */
import { useNavigationProgressStore } from './store/navigationProgress';

export function onRouterTransitionStart(url) {
	// A member call, not a hook call, so react-hooks/rules-of-hooks does not apply.
	useNavigationProgressStore.getState().start(url);
}
